import "./Candidatar.css";
import Imagens from "../../../components/IMAGESCOMPONENT/ImageComponent";

export default function Candidatar() {
  return (
    <div className="candidatar-page">

      {/* HEADER */}
      <header className="portal-header">
        <div className="header-left">
          <img src={Imagens.Logo} alt="Eliandro Alimentos" className="logo" />
          <span className="divider" />
          <h1>Portal do Candidato</h1>
        </div>
      </header>

      {/* TÍTULO */}
      <div className="portal-title">
        <h2>Candidatura</h2>
      </div>

      {/* CONTEÚDO */}
      <div className="candidatar-content">
        <h3>FORMULÁRIO DE CANDIDATURA</h3>

        <form className="candidatar-form">

          {/* DADOS PESSOAIS */}
          <section>
            <h4>Dados Pessoais</h4>

            <div className="form-row">
              <input type="text" placeholder="Nome completo" />
              <input type="text" placeholder="CPF" />
            </div>

            <div className="form-row">
              <input type="email" placeholder="E-mail" />
              <input type="tel" placeholder="Telefone / WhatsApp" />
            </div>

            <div className="form-row">
              <input type="date" />
              <input type="text" placeholder="Cidade / Estado" />
            </div>
          </section>

          {/* ENDEREÇO */}
          <section>
            <h4>Endereço</h4>

            <div className="form-row">
              <input type="text" placeholder="Rua" />
              <input type="text" placeholder="Número" />
              <input type="text" placeholder="Bairro" />
            </div>

            <div className="form-row">
              <input type="text" placeholder="CEP" />
              <input type="text" placeholder="Cidade" />
              <input type="text" placeholder="Estado" />
            </div>
          </section>

          {/* EXPERIÊNCIA */}
          <section>
            <h4>Experiência Profissional</h4>

            <textarea placeholder="Descreva suas experiências profissionais, últimos empregos e funções exercidas" />
          </section>

          {/* CURSOS */}
          <section>
            <h4>Cursos e Formação</h4>

            <textarea placeholder="Cursos realizados, formações, treinamentos, certificações" />
          </section>

          {/* INFORMAÇÕES ADICIONAIS */}
          <section>
            <h4>Informações Adicionais</h4>

            <textarea placeholder="Conte-nos um pouco mais sobre você" />
          </section>

          {/* ANEXOS */}
          <section>
            <h4>Anexos</h4>

            <div className="form-row">
              <label className="file-input">
                Foto (opcional)
                <input type="file" accept="image/*" />
              </label>

              <label className="file-input">
                Currículo (PDF ou DOC)
                <input type="file" accept=".pdf,.doc,.docx" />
              </label>
            </div>
          </section>

          {/* AÇÕES */}
          <div className="form-actions">
            <button type="submit" className="btn-primary">
              Candidatar-se
            </button>

            <a href="/portalcandidato" className="btn-cancel">
              Cancelar
            </a>
          </div>
        </form>
      </div>

      {/* FOOTER */}
      <footer className="portal-footer">
        04733769500
      </footer>
    </div>
  );
}
